import { createTheme } from "@mui/material/styles";
import mazotoTheme from "./mazotoTheme";

export const CustomTheme = (primaryColor: string) =>
    createTheme({
        palette: {
            ...mazotoTheme.palette,
            primary: {
                main: primaryColor,
            },
        },
    });